@import 'styles/mixins';
@import 'styles/variables';

.renameWrapper {
  margin: 0 12px 0 14px;
  height: 36px;
}

.fileIcon {
  margin: 0;
}

@include for-medium-phone-only {
  .row {
    margin: 0 12px;

    &.applyBorder {
      border-bottom: 1px solid var(--neutral-5);

      [data-design-system='blaze'] & {
        border-bottom: none;
      }
    }
  }
}

@include for-phone-only {
  .row {
    height: 40px;
  }
}

.actionsButton {
  svg {
    width: 24px;
    height: 24px;
  }
}
